import template from './selectionList.html';
import './selectionList.scss';

export class SelectionListController {
  constructor($q) {
    'ngInject';

    this.$q = $q;
    this.currentPage = 1;
    this.totalPages = 0;
    this.offset = 0;
    this.litmit = 0;
    this.offsetCaption = 0;
    this.litmitCaption = 0;
  }
  updatePaginationInfo() {
    this.currentPage = 1;
    this.totalPages = Math.max(Math.ceil(this.total / this.itemsPerPage), 1);
    this.updatePaginationOffset();
  }
  updatePaginationOffset(addingMoreItems) {
    let itemsToAdd = 0;
    if (addingMoreItems) {
      itemsToAdd = (this.items.length + this.itemsPerPage) > this.total ?
        this.total - this.items.length :
        this.itemsPerPage;
    }

    const itemsLength = this.items.length + itemsToAdd;
    const offset = ((this.currentPage - 1) * this.itemsPerPage);

    this.offsetCaption = offset;
    this.offset = offset ? 0 - (itemsLength - offset) : 0;
    this.limit = Math.min(this.itemsPerPage, itemsLength - offset);
    this.limitCaption = offset + this.limit;
  }
  goBack() {
    let result;
    if (this.loading || this.currentPage === 1) {
      result = this.$q.reject(new Error('Can go back right now'));
    } else {
      this.currentPage -= 1;
      this.updatePaginationOffset();
    }

    return result;
  }
  goForward() {
    let result;
    if (this.loading || this.currentPage === this.totalPages) {
      result = this.$q.reject(new Error('Can go back right now'));
    } else {
      let addingMoreItems = false;
      if (
        (this.itemsPerPage * (this.currentPage + 1)) > this.items.length &&
        this.items.length < this.total
      ) {
        addingMoreItems = true;
        this.onRequestMoreItems();
      }

      this.currentPage += 1;
      this.updatePaginationOffset(addingMoreItems);
    }

    return result;
  }
  selectItem($event, item) {
    if (this.disableSelection) {
      $event.preventDefault();
    } else if (this.onItemSelection) {
      this.onItemSelection({ $event, item });
    }
  }
  $onChanges({ total }) {
    if (total) {
      this.updatePaginationInfo();
    }
  }
}

export default {
  controller: SelectionListController,
  template,
  bindings: {
    items: '<',
    itemsDisplayProperties: '<',
    itemsRoute: '@',
    selectedItemId: '<',
    flaggedItemId: '<',
    flaggedBadgeValue: '@',
    total: '<',
    loading: '<',
    itemsPerPage: '<',
    customNoResultsMessage: '@',
    disableSelection: '<',
    onRequestMoreItems: '&',
    onItemSelection: '&',
  },
};
